const BASE_URL = '/pv-admission-templates'

function getAll(httpClient) {
  return httpClient({ url: BASE_URL, method: 'GET' }).then(
    (response) => response.data
  )
}

function create(name, httpClient) {
  return httpClient({
    url: BASE_URL,
    method: 'POST',
    data: JSON.stringify({ name }),
  }).then((response) => response.data)
}

function rename(templateId, name, httpClient) {
  return httpClient({
    url: `${BASE_URL}/${templateId}`,
    method: 'PATCH',
    data: JSON.stringify({ name }),
  }).then((response) => response.data)
}

function remove(templateId, httpClient) {
  return httpClient({ url: `${BASE_URL}/${templateId}`, method: 'DELETE' })
}

function saveDocument(templateId, stagingKey, acceptWarnings, httpClient) {
  return httpClient({
    url: `${BASE_URL}/${templateId}/document`,
    method: 'POST',
    data: JSON.stringify({ stagingKey, acceptWarnings }),
  })
    .then((response) => response.data)
    .catch((err) => {
      // Sent again with acceptWarnings to save it despite the warnings
      err.stagingKey = stagingKey
      throw err
    })
}

// Sends the Word document to a staging key, then asks the API to check it
// and associate it with the template.
function uploadDocument(templateId, file, httpClient, worldHttpClient) {
  return httpClient({
    url: `${BASE_URL}/${templateId}/document/upload-url`,
    method: 'POST',
  })
    .then((response) => {
      const { uploadUrl, uploadHttpMethod, uploadHeaders, stagingKey } =
        response.data
      return worldHttpClient({
        url: uploadUrl,
        method: uploadHttpMethod,
        headers: { ...(uploadHeaders || {}), 'Content-Type': file.type },
        data: file,
      }).then(() => stagingKey)
    })
    .then((stagingKey) =>
      saveDocument(templateId, stagingKey, false, httpClient)
    )
}

// Saves a document already sent by uploadDocument despite its warnings
// (unknown fields, no field at all)
function acceptDocumentWarnings(templateId, stagingKey, httpClient) {
  return saveDocument(templateId, stagingKey, true, httpClient)
}

export default {
  getAll,
  create,
  rename,
  remove,
  uploadDocument,
  acceptDocumentWarnings,
}
